import {useField, FieldHookConfig} from 'formik';
import Editor, {EditorProps, ContentEditableEvent} from 'react-simple-wysiwyg';
import React from "react";

type WysiwygEditorFieldProps = FieldHookConfig<string> & {
    editorProps?: EditorProps;
    label?: string;
    showSmall?: boolean
};

const WysiwygEditorField: React.FC<WysiwygEditorFieldProps> = ({name, label, showSmall = false, editorProps, ...rest}) => {
    const [field, , helpers] = useField<string>(name);

    const handleChange = (event: ContentEditableEvent) => {
        helpers.setValue(event.target.value);
    };

    const makeTextSmaller = () => {
        const selection = window.getSelection();
        if (!selection || selection.rangeCount === 0) return;

        const range = selection.getRangeAt(0);
        const selectedText = range.toString();
        if (selectedText.trim() === "") return;

        const smallText = `<span style="font-size: 11px;">${selectedText}</span>`;
        document.execCommand('insertHTML', false, smallText);

        const editorContent = document.getElementById(`editor-${name}`);
        if (editorContent) {
            helpers.setValue(editorContent.innerHTML);
        }
    };

    return (
        <tr>
            <th>
                {label}:
            </th>
            <td>
                {showSmall &&
                <div>
                  <button type="button" onClick={makeTextSmaller} style={{border: '1px solid black'}}>Väike tekst
                  </button>
                </div>
                }
                <Editor
                    id={`editor-${name}`}
                    value={field.value}
                    {...editorProps}
                    {...rest}
                    onChange={handleChange}
                />
            </td>
        </tr>
    );
};

export default WysiwygEditorField;
